import { Preferences } from '@capacitor/preferences';
import { toDeviceModifierId } from '@macro-tracker/models';
import { generateId } from '@/utils/id';

const DEVICE_ID_KEY = 'macrotracker:device-id';

let deviceIdPromise: Promise<string> | null = null;

export function initializeDeviceIdentity(): Promise<string> {
  if (deviceIdPromise) return deviceIdPromise;

  deviceIdPromise = (async () => {
    const stored = await Preferences.get({ key: DEVICE_ID_KEY });
    const existing = stored.value?.trim();
    if (existing) return existing;

    const deviceId = generateId();
    await Preferences.set({ key: DEVICE_ID_KEY, value: deviceId });
    return deviceId;
  })();

  deviceIdPromise.catch(() => {
    deviceIdPromise = null;
  });
  return deviceIdPromise;
}

export async function getDeviceId(): Promise<string> {
  return initializeDeviceIdentity();
}

export async function getDeviceModifierId(): Promise<string> {
  return toDeviceModifierId(await getDeviceId());
}
